import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import styles from './PartnerDefaultHint.module.scss';

type Props = {
  text: string;
  className?: string;
};

// What a partner template copies for an empty block, set apart where a value
// would stand. It is not a value: choosing one replaces it, and the AI never
// reads it.
export const PartnerDefaultHint: FC<Props> = ({ text, className }) => {
  const { formatMessage } = useIntl();

  return (
    <span
      className={cn('p2', styles.hint, className)}
      title={formatMessage({
        id: 'workspace.note.partnerDefaultHint',
        defaultMessage:
          "The template's default: it is copied unless you choose a value",
      })}
      data-component="workspace-note-partner-default"
    >
      {text}
    </span>
  );
};
